/*
  8888888b. 8888888  .d8888b.        d88888                   
  888   Y88b  888   d88P  Y88b      d888888                   
  888   d88P  888   888            d88P 888 88888b.  88888b.  
  8888888P"   888   888           d88P  888 888 "88b 888 "88b 
  888         888   888          d88P   888 888  888 888  888 
  888         888   Y88b  d88P  d8888888888 888 d88P 888 d88P 
  888       8888888  "Y8888P"  d88P     888 88888P"  88888P"  
                                          888      888
                                          888      888

* Copyright Manuel Valle C., AromaItaliano SA, Costa Rica
*
* trumbowyg.picapp.js v1.2
* Forms plugin for Trumbowyg
*/
(function($) {
    'use strict';

    var defaultOptions = {
        questionTag: 'question',
		isAdmin: false,
		questions: []
    };

    // Adds the language variables
    $.extend(true, $.trumbowyg, {
        langs: {
            en: {
				design: 'Style',
				lists: 'Lists',
				image: 'Media',
                survey: 'Form',
				surveyText: 'Text',
				surveyTextarea: 'Text Area',
				surveyStars: 'Stars',
				surveyBool: 'Boolean',
				surveyLikert: 'Likert',
				surveyRange: 'Range',
				surveyOption: 'Options',
				surveyCkeck: 'Checks',
				surveyUpload: 'File',
				surveyAlert: 'Select first the question text! \n You can define a title with any of the header styles.'
			},
            es: {
				design: 'Estilo',
				lists: 'Listas',
				image: 'Media',
                survey: 'Formulario',
				surveyText: 'Texto',
				surveyTextarea: 'Multi-linea',
				surveyStars: 'Estrellas',
				surveyBool: 'Boolean',
				surveyLikert: 'Escala Likert',
				surveyRange: 'Rango',
				surveyOption: 'Opciones',
				surveyCkeck: 'Checks',
				surveyUpload: 'File',
				surveyAlert: 'Seleccionar primero el texto de la pregunta! \n Puedes incluir definir un titulo con cualquiera de los estilos H1, H2, H3, H4.'
            },
        },
        plugins: {
            survey: {
				addTag: function(label, type) {
					return { name: label, html: html, attributes: {type: type} };
				},
                shouldInit: function(trumbowyg) {
                    //return trumbowyg.o.plugins.hasOwnProperty('questions');
                    return true; 
                },
                init: function(trumbowyg) {
                    trumbowyg.o.plugins.survey = $.extend(true, {}, defaultOptions, trumbowyg.o.plugins.survey || {});
					trumbowyg.addBtnDef('survey', {
						dropdown: questionSelector(trumbowyg),
						hasIcon: true,
						ico: 'question-close-par',
						text: trumbowyg.lang.survey
					});
                }
            }
        }
    });

	//var html = '<span contenteditable="false" class="qt-start"><i class="qt-{type} sm"></i></span>\n{title}\n{description}\n<span contenteditable="false" class="qt-end"><i class="qt-{type}-close sm"></i></span>';
	var html = '{title}\n{description}\n';

    // Creates the question-selector dropdown.
    function questionSelector(trumbowyg) {

		var questions = [];
		var available = [
			{ name: trumbowyg.lang.surveyText, html: html, attributes: {type: 'text', format: 'text'} },
			{ name: trumbowyg.lang.surveyTextarea, html: html, attributes: {type: 'textarea'} },
			{ name: trumbowyg.lang.surveyStars, html: html, attributes: {type: 'stars', group: ''} },
			{ name: trumbowyg.lang.surveyBool, html: html, attributes: {type: 'bool'} },
			{ name: trumbowyg.lang.surveyLikert, html: html, attributes: {type: 'likert', scale: 'agreement'} },
			{ name: trumbowyg.lang.surveyRange, html: html, attributes: {type: 'range', minimum: 0, maximum: 100} },
			{ name: trumbowyg.lang.surveyOption, html: html, attributes: {type: 'options', items: []} },
			{ name: trumbowyg.lang.surveyCkeck, html: html, attributes: {type: 'checks', items: []} }
		];
		// Added dinamically
		if (trumbowyg.o.plugins.survey.isAdmin) {
			available.push({ name: trumbowyg.lang.surveyUpload, html: html, attributes: {type: 'upload', mime: 'image/jpeg, image/png', group: ''} })
		}
        available = available.concat(trumbowyg.o.plugins.survey.questions);

        $.each(available, function(index, question) {
            trumbowyg.addBtnDef('survey_' + index, {
				hasIcon: true,
				ico: 'question-'+question.attributes.type,
				title: question.name,
				fn: function(){
					trumbowyg.saveRange();
					// Alerts if nothing is selected
					var selectedText = trumbowyg.getRangeText();
					if (selectedText=='') {
						return bootbox.alert({
							message: trumbowyg.lang.surveyAlert,
							size: 'small'
						});
					};

					const keepOnly = function(tags) {
						// Keep only tags in the array passed as argument
						return utils.stripTags.filter(function(el) {
							return tags.indexOf(el)<0;
						});
					};
					var fragment = trumbowyg.range.cloneContents(); //cloneContents
					// Sets Title using the content of the first Hn tag or use a default value if none
					var titleNode = fragment.querySelector('h1, h2, h3, h4'); // Search for H tags for title
					var title = '<h1>'+ (titleNode!=null ? utils.stripHTMLTags(titleNode.innerHTML, keepOnly(['a', 'em', 'strong'])) : 'Pregunta') +'</h1>';
					// Sets Description using the contents of all P tags or an empty P if none 
					var descriptionNodes = fragment.querySelectorAll('p'); //Search P tags for description 
					var description = ''; //'<p><br></p>';
					$(descriptionNodes).each(function(i, e) {
						// Removes unwanted tags
						e.innerHTML = utils.stripHTMLTags(e.innerHTML, keepOnly(['a', 'em', 'strong']));
						if (e.innerHTML) {
							description += (i!=0) ? e.outerHTML : '';
						}
					});
					var attributes = '';
					for (var key in question.attributes) {
						attributes += 'data-' + key + '="'+question.attributes[key]+'" '
					}

					var content = question.html.replace(/{type}/g, question.attributes.type);
					content = content.replace('{title}', title).replace('{description}', description || '<p><br></p>');
					var qID = utils.generateUUID().split('-'); // Short UUID uses 2nd group only
					var wrapper = $('<wrapper>');
					wrapper.append('<'+trumbowyg.o.plugins.survey.questionTag+' id="'+qID[1]+'" data-id="'+qID[1]+'" '+attributes+'>');
					wrapper.append('\n');
					wrapper.find(trumbowyg.o.plugins.survey.questionTag).append(content);
					/*
					 *		Expand selection range to include the also the container nodes.
					 *		A question block must have at least one Hn block and one ore more sibling P blocks:
					 *		<h..>...........</h..><p>...........</p><p>...........</p>
					 */					 
					var baseNode = trumbowyg.doc.getSelection().baseNode;
					if (baseNode.nodeName=='#text') {
						trumbowyg.range.setStartAfter(baseNode)
					}
					// Expanding Range start
					while (trumbowyg.range.startContainer.parentNode.nodeName!=='DIV') {
						// Prepend an empty P element as a separator from previous question block
						if (['P','H1','H2','H3','H4'].indexOf(trumbowyg.range.startContainer.parentNode.nodeName)>-1 && (
							!trumbowyg.range.startContainer.parentNode.previousSibling ||
							trumbowyg.range.startContainer.parentNode.previousSibling.nodeName===trumbowyg.o.plugins.survey.questionTag.toUpperCase() ||
							trumbowyg.range.startContainer.parentNode.previousSibling.nodeValue==='\n')
						) wrapper.prepend('<p><br></p>\n');
						trumbowyg.range.setStartBefore(trumbowyg.range.startContainer.parentNode);
					} 
					// Expanding Range end
					do {
						if (trumbowyg.range.endContainer.parentNode.nodeName!=='DIV' && (
							!trumbowyg.range.endContainer.parentNode.nextSibling ||
							trumbowyg.range.endContainer.parentNode.nextSibling.nodeName===trumbowyg.o.plugins.survey.questionTag.toUpperCase() ||
							trumbowyg.range.endContainer.parentNode.nextSibling.nodeValue=== '\n')
						) wrapper.append('<p><br></p>\n');
						if (trumbowyg.range.endContainer.parentNode.nodeName!=='DIV') {
							trumbowyg.range.setEndAfter(trumbowyg.range.endContainer.parentNode);
						}
					} while (trumbowyg.range.endContainer.parentNode.nodeName!=='DIV');
					// Replace range contents with the question HTML block
					trumbowyg.range.deleteContents();
					trumbowyg.range.insertNode(wrapper.get(0));
					trumbowyg.$ed.find('wrapper > article').unwrap();
					trumbowyg.syncCode();
					trumbowyg.$c.trigger('tbwchange');
                }
            });
            questions.push('survey_' + index);
        });

        return questions;
    }
})(jQuery);